import axios from 'axios';
import keycloak from './keycloak';
import { TRACEHUNT_API_URL } from '../config';

const NO_RETRY_HEADER = 'x-no-retry';

const tracehuntApi = axios.create({
  baseURL: TRACEHUNT_API_URL,
});

tracehuntApi.interceptors.request.use(
  async (config) => {
    if (keycloak.authenticated && keycloak.token) {
      try {
        await keycloak.updateToken(5);
      } catch {
        keycloak.login();
        return Promise.reject(new Error('Token refresh failed'));
      }
      config.headers.Authorization = `Bearer ${keycloak.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

tracehuntApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest.headers[NO_RETRY_HEADER]) {
      originalRequest.headers[NO_RETRY_HEADER] = 'true';
      try {
        await keycloak.updateToken(-1);
        originalRequest.headers.Authorization = `Bearer ${keycloak.token}`;
        return tracehuntApi(originalRequest);
      } catch {
        keycloak.login();
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

// --- Types ---

export interface UserConfig {
  max_threads_per_task: number;
  max_parallel_tasks: number;
}

// --- API calls ---

export async function getAdminUserConfig(username: string): Promise<{ user_config: UserConfig }> {
  const res = await tracehuntApi.get(`/admin/users/${encodeURIComponent(username)}/config`);
  return res.data;
}

export async function setAdminUserConfig(username: string, userConfig: UserConfig): Promise<{ user_config: UserConfig }> {
  const res = await tracehuntApi.post(`/admin/users/${encodeURIComponent(username)}/config`, { user_config: userConfig });
  return res.data;
}

export default tracehuntApi;
